package com.nonopn.skywatcher.design.local

import androidx.compose.runtime.compositionLocalOf
import com.nonopn.skywatcher.design.widgets.popup.PopupLocalModel

val LocalConfirmPopup = compositionLocalOf<PopupLocalModel> { error("No LocalPopup") }
